export const andUpTextMapping = Object.freeze({
  'cs-CZ': 'Od {0}',
  da: '{0} og opefter',
  de: 'Ab {0}',
  'en-GB': 'from {0}',
  'en-IE': 'from {0}',
  es: 'Desde {0}',
  'et-EE': '{0} ja \u00fcles',
  fi: '{0} tai enemm\u00e4n',
  fr: 'A partir de {0}',
  'fr-CA': '{0} et plus',
  hr: 'od {0}',
  it: 'A partire da {0}',
  'lt-LT': 'Nuo {0}',
  'lv-LV': 'Sākot ar {0}',
  nb: '{0} og oppover',
  nl: 'Vanaf {0}',
  'nl-BE': 'Vanaf {0}',
  pl: '{0} i wi\u0119cej',
  pt: '{0} e superior',
  'pt-PT': '{0} e superior', // Need to specify pt-PT because it has store code of ES
  'ro-RO': 'De la {0}',
  sl: '{0} in ve\u010d',
  sv: '{0} och upp\u00e5t',
  'sv-SE': 'Fr\u00E5n {0}',
});

export default andUpTextMapping;
